import React from "react";
import { Student } from "../types/Student";

type DisplayStudent = Student & {
  attendance?: string | null;
  timestamp?: string | Date;
};

interface DialDisplayProps {
  value: string;
  placeholder?: string;
  matchedStudent?: DisplayStudent | null;
  resultStudent?: DisplayStudent | null;
  studentBoxOpacity?: number;
}

export default function DialDisplay({
  value,
  placeholder = "출결번호를 입력해주세요",
  matchedStudent,
  resultStudent,
  studentBoxOpacity = 1,
}: DialDisplayProps) {
  const hasInput = value.length > 0;
  const infoText = "출결번호를 입력해주세요. 잘못 입력했다면 ↻을 눌러 처음부터 다시 입력하거나, ⌫을 눌러 마지막 숫자만 지우고 다시 입력하세요.";
  const showName = !!(matchedStudent || resultStudent);
  const studentName = (matchedStudent || resultStudent)?.name;

  return (
    <div style={{
      position: "relative",
      width: "90%",
      maxWidth: "90%",
      minHeight: "180px",
      borderRadius: "12px",
      background: "#fff",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      padding: "24px 32px",
      textAlign: "center",
      gap: "8px"
    }}>
      {/* 상부: 메시지 또는 이름 */}
      <div style={{
        flex: 1,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: showName ? "24px" : "16px",
        color: showName ? "#222" : "#666",
        fontWeight: showName ? 700 : 500,
        lineHeight: 1.6,
        animation: showName ? "none" : "float 3s ease-in-out infinite",
        opacity: resultStudent ? studentBoxOpacity : 1,
        transition: resultStudent ? "opacity 3s ease-out" : "opacity 0.5s ease-out"
      }}>
        {showName ? `${studentName} 학생` : infoText}
      </div>

      {/* 하부: 숫자 또는 처리 결과 */}
      <div style={{
        flex: 1,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: hasInput || resultStudent ? "28px" : "0px",
        color: "#222",
        letterSpacing: hasInput ? "10px" : "0px",
        fontWeight: 800,
        minHeight: "36px",
        gap: "6px",
        opacity: resultStudent ? studentBoxOpacity : 1,
        transition: resultStudent ? "opacity 3s ease-out" : "opacity 0.5s ease-out"
      }}>
        {resultStudent ? (
          <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "28px" }}>
            <span style={{
              padding: "6px 16px",
              background: resultStudent.attendance === "등원" ? "#1f883d" : "#2466c2",
              color: "#fff",
              borderRadius: "6px",
              fontWeight: 700,
              fontSize: "20px"
            }}>
              {resultStudent.attendance}
            </span>
            <span style={{ fontSize: "24px", fontWeight: 600 }}>하였습니다.</span>
          </div>
        ) : (
          hasInput ? value : ""
        )}
      </div>

      {/* floating animation 정의 */}
      {!showName && (
        <style>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px); opacity: 0.8; }
            50% { transform: translateY(-8px); opacity: 1; }
          }
        `}</style>
      )}
    </div>
  );
}

